module.exports = __webpack_public_path__ + "static/media/header_bg_sm.17a1fe87.webp";